export const DATASET = {
    QUEUESTATS: "wxcc.rtd.queuestats",
    TEAMSTATS: "wxcc.rtd.teamstats"
};
